// extracted by mini-css-extract-plugin
export var arrow = "index-module--arrow--82aeb";
export var btn_container = "index-module--btn_container--d3ae7";
export var btn_label = "index-module--btn_label--fa281";
export var btn_with_border_container = "index-module--btn_with_border_container--28f64";